/**
 * KALENDERHILFE DER OBERFLÄCHE (Tickets-Spec F18): `web` darf die Domäne nicht importieren und
 * bekommt die Feiertage als Liste vom Server. Hier steht nur „Samstag, Sonntag oder in der
 * Liste" und die Schnellknöpfe als Vorschau; verbindlich ist das Datum, das der Server beim
 * Speichern setzt. Die Prüffälle teilt diese Datei mit der Domäne
 * (`packages/domain/test/fixtures/schnellknoepfe.json`), damit beide nicht auseinanderlaufen.
 */
function utc(tag) {
    const [j, m, t] = tag.split("-").map(Number);
    return new Date(Date.UTC(j, m - 1, t));
}
function iso(d) { return d.toISOString().slice(0, 10); }
export function tagPlus(tag, n) {
    return iso(new Date(utc(tag).getTime() + n * 86_400_000));
}
export function monatPlus(tag, n) {
    const d = utc(tag);
    const letzter = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + n + 1, 0)).getUTCDate();
    return iso(new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + n, Math.min(d.getUTCDate(), letzter))));
}
export function istWochenendTag(tag) {
    const w = utc(tag).getUTCDay();
    return w === 0 || w === 6;
}
export function istFreierTag(tag, feiertage) {
    return istWochenendTag(tag) || feiertage.includes(tag);
}
export function naechsterWerktagLaut(tag, feiertage) {
    let t = tag;
    while (istFreierTag(t, feiertage))
        t = tagPlus(t, 1);
    return t;
}
export function schnellknopfDatum(knopf, gesetzt, heute, feiertage) {
    if (knopf === "KEINE")
        return null;
    const basis = gesetzt !== null && gesetzt > heute ? gesetzt : heute;
    const roh = knopf === "TAG" ? tagPlus(basis, 1) : knopf === "WOCHE" ? tagPlus(basis, 7) : monatPlus(basis, 1);
    return naechsterWerktagLaut(roh, feiertage);
}
/**
 * Die VORGABE der Wiedervorlage beim Anlegen einer Aufgabe (F34): mit Tagen heute + n Tage, auf
 * den nächsten Werktag laut Liste gerückt. Die Vorgabe steht an GENAU EINER Stelle:
 * `WIEDERVORLAGE_VORGABE_TAGE = null` schaltet sie ab, dann startet das Anlegen ohne
 * Wiedervorlage. Entscheid 136 (Dirk 18.10.): keine Vorgabe — die neue Aufgabe steht oben in
 * „Jetzt“.
 */
export const WIEDERVORLAGE_VORGABE_TAGE = null;
export function vorgabeWiedervorlage(heute, feiertage, tage = WIEDERVORLAGE_VORGABE_TAGE) {
    return tage === null ? null : naechsterWerktagLaut(tagPlus(heute, tage), feiertage);
}
//# sourceMappingURL=kalenderHilfe.js.map